import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  SET_CAMERA_OPEN,
  SET_CAMERA_CLOSED,
  SET_PREFERRED_CAMERA,
  RESTORE_CAMERA_STATE
} from '../constants';

export function SetCameraOpen(location) {
  return async dispatch => {
    dispatch({
      type: SET_CAMERA_OPEN,
      payload: {
        isOpen: true,
        location: location
      }
    });

    try {
      await AsyncStorage.setItem('cameraState', JSON.stringify({
        isOpen: true,
        location: location,
        timestamp: new Date().toISOString()
      }));
    } catch (error) {
      console.error('Error persisting camera open state:', error);
    }
  };
}

export function SetCameraClosed() {
  return async dispatch => {
    dispatch({
      type: SET_CAMERA_CLOSED,
      payload: {
        isOpen: false,
        location: null
      }
    });

    try {
      await AsyncStorage.setItem('cameraState', JSON.stringify({
        isOpen: false,
        location: null,
        timestamp: new Date().toISOString()
      }));
    } catch (error) {
      console.error('Error persisting camera closed state:', error);
    }
  };
}

export function SetPreferredCamera(cameraId) {
  return async dispatch => {
    dispatch({
      type: SET_PREFERRED_CAMERA,
      payload: cameraId
    });

    try {
      await AsyncStorage.setItem('preferredCameraId', cameraId);
    } catch (error) {
      console.error('Error persisting preferred camera:', error);
    }
  };
}

export function RestoreCameraState() {
  return async dispatch => {
    try {
      const cameraStateStr = await AsyncStorage.getItem('cameraState');
      const preferredCameraId = await AsyncStorage.getItem('preferredCameraId');

      let cameraState = {
        isOpen: false,
        location: null
      };

      if (cameraStateStr) {
        const parsedState = JSON.parse(cameraStateStr);
        cameraState = {
          isOpen: parsedState.isOpen || false,
          location: parsedState.location || null
        };
      }

      dispatch({
        type: RESTORE_CAMERA_STATE,
        payload: {
          ...cameraState,
          preferredCameraId: preferredCameraId || null
        }
      });
    } catch (error) {
      console.error('Error restoring camera state:', error);
      dispatch({
        type: RESTORE_CAMERA_STATE,
        payload: {
          isOpen: false,
          location: null,
          preferredCameraId: null
        }
      });
    }
  };
}
